var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1413 18.3583C13.958 18.5416 13.8663 18.7555 13.8663 19C13.8663 19.2444 13.958 19.4583 14.1413 19.6416L19.2747 24.775C19.5497 25.05 19.8778 25.119 20.2592 24.9821C20.6405 24.8452 20.8318 24.5623 20.833 24.1333L20.833 13.8666C20.833 13.4388 20.6417 13.1565 20.2592 13.0196C19.8766 12.8827 19.5485 12.9512 19.2747 13.225L14.1413 18.3583ZM0.666343 19C0.666343 16.4638 1.1479 14.0805 2.11101 11.85C3.07412 9.6194 4.38006 7.67912 6.02884 6.02913C7.67884 4.37913 9.61912 3.07318 11.8497 2.11129C14.0802 1.1494 16.4636 0.667847 18.9997 0.666625C21.5358 0.666625 23.9191 1.14818 26.1497 2.11129C28.3802 3.0744 30.3205 4.38035 31.9705 6.02913C33.6205 7.67913 34.9265 9.6194 35.8883 11.85C36.8502 14.0805 37.3318 16.4638 37.333 19C37.333 21.5361 36.8515 23.9194 35.8883 26.15C34.9252 28.3805 33.6193 30.3208 31.9705 31.9708C30.3205 33.6208 28.3802 34.9273 26.1497 35.8905C23.9191 36.8536 21.5358 37.3345 18.9997 37.3333C16.4636 37.3333 14.0802 36.8517 11.8497 35.8886C9.61912 34.9255 7.67884 33.6196 6.02884 31.9708C4.37884 30.3208 3.07229 28.3805 2.10918 26.15C1.14606 23.9194 0.665118 21.5361 0.666343 19Z",
    fill: "#062644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevblue);
export default __webpack_public_path__ + "static/media/prevblue.c91c700f1c2d2091423520348548cea9.svg";
export { ForwardRef as ReactComponent };